import React, { useEffect, useState } from "react";
import CText from "../../common/CText";
import { View, ScrollView, Animated,TextInput,FlatList ,TouchableOpacity,Text} from "react-native";
import CInput from "../../common/CInput";
import CustomButton from "../../common/CustomButton";
import CHeader from "../../common/CHeader";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import { COLORS } from "../../constant";
import CDropdown from "../../common/CDropdown";
import CSlider from "../../common/CSlider";
import { updateLoan } from "../../api/usedCarLoan";
import Loader from "../../common/Loader";
import ModalAlert from "../../common/ModalAlert";
import { getEmployerInfo } from '../../api/usedCarLoan'
import pickerConstant from "../../constant/pickerConstant";
import VehicleInfo from './VehicleInfo'

export default function EmpInformation(props) {
    const styles = useStyles();
    const [currentPage, setCurrentPage] = useState("empInfo")
    const [data, setData] = useState({
        brand: '',
        model: '',
        make: '',
        assetGroup: "",
        loanAmtRequested: '',
        applicationId: '',
        monthsAtCurentCompany: '',
        yearsAtCurrentCompany: '',
        annualGrossSalary: '',
        employerName: '',
        employmentType: ''
    })
    const [searchText, setSearchText] = useState("");
    const [showSearchDropdown, setShowSearchDeopdown] = useState(false);
    const [employerList, setEmployerList] = useState([])
    const [disableBtn, setDisableBtn] = useState(false)
    const [assetValue, setAssetValue] = useState('');
    const [loading, setLoading] = useState(false)
    const [alertModalVisible, setAlertModalVisible] = useState(false);
    const [alertModal, setAlertModal] = useState({
        title: "",
        status: "",
        message: "",
        navigateScreen: "",
        actionButton: "",
    });

    const onCloseModal = () => {
        setAlertModalVisible(false);
        if (alertModal.navigate) {
            props.setActiveScreen(alertModal.navigate)
        }
    };

    const onHandleInput = (key, value) => {
        const dataObj = { ...data }
        dataObj[key] = value
        setData(dataObj)
    }

    const update_loan = () => {
        setLoading(true);
        const param = {
            vehicleInfo: {
                brand: data.brand,
                model: data.model,
                make: data.make,
                assetGroup: assetValue
            },
            loanInfo: {
                loanAmtRequested: data.loanAmtRequested,
                applicationId: props.statusData?.data?.applicationId,
            },
            employmentInfo: {
                monthsAtCurrentCompany: data.monthsAtCurentCompany,
                yearsAtCurrentCompany: data.yearsAtCurrentCompany,
                annualGrossSalary: data.annualGrossSalary,
                employerName: data.employerName,
                employmentType: data.employmentType,
            },
        };
        updateLoan(param)
            .then((res) => {
                setLoading(false);
                if (res.statusCode == 500 || res.statusCode == -1073) {
                    setAlertModalVisible(true);
                    setAlertModal({
                        title: "Error",
                        status: "error",
                        message: res.message,
                        navigateScreen: "",
                        actionButton: "OK",
                    });
                }
                if (res.statusCode == 1073) {
                    setAlertModalVisible(true);
                    setAlertModal({
                        title: "Successfull",
                        status: "success",
                        message: res.message,
                        navigateScreen: "",
                        navigate: "CarLoanIndex",
                        actionButton: "OK",
                    });
                }
            })
            .catch((err) => { });
    };


    const handlePageChange = () => {
        if (currentPage == "empInfo") setCurrentPage("vehicleInfo");
        if (currentPage == "vehicleInfo") setCurrentPage("loanInfo");
    };

    const handleOnPress = () => {
        if (disableBtn) {
            if (currentPage == "loanInfo") update_loan();
            else handlePageChange();
        }
    }

    useEffect(() => {
        console.log(data, "data567")
        if (currentPage == 'empInfo') {
            if (data.employerName && data.employerName != (undefined || '')
                && data.employmentType && data.employmentType != (undefined || '')
                && data.annualGrossSalary && data.annualGrossSalary != (undefined || '')
                && data.yearsAtCurrentCompany && data.yearsAtCurrentCompany != (undefined || '')
                && data.employmentType && data.employmentType != (undefined || '')
                && (data.monthsAtCurentCompany != "" || data.monthsAtCurentCompany == "0")
            ) {
                setDisableBtn(true)
            }
        } else if (currentPage == 'loanInfo') {
            if (data.loanAmtRequested && data.loanAmtRequested != (undefined || '')) {
                setDisableBtn(true)
            } else setDisableBtn(false)
        } else if (currentPage == 'vehicleInfo') {
            if (data.brand && data.brand != (undefined || '') &&
                data.model && data.model != (undefined || '') &&
                data.make && data.make != (undefined || '')) {
                setDisableBtn(true)
            } else setDisableBtn(false)
        } else {
            setDisableBtn(false)
        }
    }, [data, currentPage])

    useEffect(() => {
        if (currentPage == "empInfo") {
            if (data.employerName && data.employerName.length > 3) {
                getEmployerList(data.employerName)
            }
        }
    }, [data.employerName])


    const getEmployerList = (param) => {
        getEmployerInfo({ search: param })
            .then((res) => {
                //-1080
                if (res.statusCode == 1080) {
                    setEmployerList(res.data.employerDtls);
                } else if (res.statusCode == -1080) {
                    setEmployerList([{ employerName: "Others" }]);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };


    const empInfo = () => {
        return (
            <View style={styles.empInfoWrapper}>
                <View style={styles.empcontentViewStyle}>
                    <View >
                        <View style={{ zIndex: 1 }}>
                            <Animated.Text style={[styles.labelStyle, {}]}>
                                {"Employer Name"}
                                <Animated.Text
                                    style={[
                                        styles.inlineError,
                                        { color: "#f00", fontSize: 15, fontWeight: "500" },
                                    ]}
                                >
                                    {" *"}
                                </Animated.Text>
                            </Animated.Text>
                            
                            <View style={styles.inputContainer}>
                <TextInput
                  value={data.employerName}
                  onChangeText={(t) => {
                    onHandleInput("employerName",t);
                    setSearchText(t)
                     setShowSearchDeopdown(true);
                  }}
                  style={[ styles.input,{borderBottomLeftRadius:searchText.length > 2 && showSearchDropdown ? 0 : 10,borderBottomRightRadius: searchText.length > 2 && showSearchDropdown ? 0 : 10, }, ]}
                />
                {searchText.length > 2 && showSearchDropdown ? (
                  <View style={styles.dropdownStyle}>
                    <FlatList
                      data={employerList.filter(item=> {
                       
                        return item.employerName.includes(data.employerName.toUpperCase())})}
                      keyExtractor = {(item, index) => index+"_"+item?.id?.toString() }
                      renderItem={( {item} ) => {
                        return (

                          <TouchableOpacity
                            style={{ paddingHorizontal: 10, justifyContent: "center", }}
                            onPress={(a) => {
                                
                              onHandleInput("employerName",item.employerName); setShowSearchDeopdown(false);
                            }}
                          >
                            <Text style={{ paddingVertical: 10, }}>{item.employerName}</Text>
                            <View
                              style={styles.bgView}
                            />
                          </TouchableOpacity>
                        );
                      }}
                    />
                  </View>
                ) : null}

              </View>
                        </View>
                        <View style={{ marginTop: 15 }}>
                            <CInput
                                label="Years in current company"
                                value={data.yearsAtCurrentCompany}
                                inputType="numeric"
                                maxLength={2}
                                onChangeText={(value) =>
                                    onHandleInput("yearsAtCurrentCompany", value)
                                }
                                mandatoryField={true}
                            />
                        </View>

                        <CInput
                            label="Annual Gross Income"
                            inputType="numeric"
                            maxLength={10}
                            value={data.annualGrossSalary}
                            onChangeText={(value) =>
                                onHandleInput("annualGrossSalary", value)
                            }
                            mandatoryField={true}
                        />
                    </View>
                    <View style={styles.empSecondViewStyle}>
                        <View style={{ zIndex: 99 }}>
                            <CDropdown
                                label="Employment Type"
                                value={data.employmentType}
                                onSelect={(value) => onHandleInput("employmentType", value)}
                                items={pickerConstant.employmentType}
                                mandatoryField={true}
                                customStyle={{ width: 299 }}
                            />
                        </View>
                        <View style={{ marginTop: 15, }}>
                            <CDropdown
                                label="Months in current company"
                                value={data.monthsAtCurentCompany}
                                onSelect={(value) =>
                                    onHandleInput("monthsAtCurentCompany", value)
                                }
                                items={pickerConstant.monthsArray}
                                mandatoryField={true}
                                customStyle={{ width: 299 }}
                            />
                        </View>
                    </View>
                </View>
            </View>
        );
    };
    const loanInfo = () => {
        return (
            <View style={styles.empInfoWrapper}>
                <CInput
                    label="Loan amount requested (₹)"
                    inputType="numeric"
                    value={data.loanAmtRequested}
                    disable={false}
                    mandatoryField={true}
                />
                <View style={{ marginTop: -30 }}>
                    <CSlider
                        onValueChange={(value) => onHandleInput("loanAmtRequested", value)}
                    />
                </View>
            </View>
        );
    };

    return (
        <>
            <View>
                <CHeader
                    onPress={
                        currentPage == "empInfo"
                            ? (val) => props.setActiveScreen(val)
                            : (val) => setCurrentPage(val)
                    }
                    navigation={`${currentPage == "empInfo"
                        ? "CarLoanIndex"
                        : currentPage == "vehicleInfo"
                            ? "empInfo"
                            : "vehicleInfo"
                        }`}
                    title={`Step ${currentPage == "empInfo" ? 3 : currentPage == "vehicleInfo" ? 4 : 5
                        } of 5`}
                />
            </View>
            <View style={styles.contentWrapper}>
                <View>
                    <CText.basicInformation>
                        {currentPage == "loanInfo"
                            ? "Loan"
                            : currentPage == "vehicleInfo"
                                ? "Vehicle"
                                : "Employement"}{" "}
                        Information
                    </CText.basicInformation>
                </View>
                {currentPage == "loanInfo"
                    ? loanInfo()
                    : currentPage == "vehicleInfo"
                        ? <VehicleInfo onHandleInput={onHandleInput} data={data} setAssetValue={setAssetValue} />
                        : empInfo()}
                <View style={styles.footer}>
                    <CustomButton
                        text="Continue"
                        onPress={handleOnPress}
                        disable={!disableBtn}
                    />
                </View>
            </View>
            {alertModalVisible ? (
                <View style={styles.overlayViewStyle}>
                    <ModalAlert
                        title={alertModal.title}
                        status={alertModal.status}
                        message={alertModal.message}
                        navigateScreen={alertModal.navigateScreen}
                        actionButton={"OK"}
                        onCloseModal={onCloseModal}
                    />
                </View>
            ) : null}
            {loading && <Loader />}
        </>
    );
}
const useStyles = CreateResponsiveStyle(
    {
        inputContainer: {
            width: 240,
            marginVertical: 5,
          },
          input: {
            // backgroundColor: "#F1F2F4",
            borderRadius: 10,
            height: 40,
            paddingHorizontal: 20,
            borderWidth: 2,
            borderColor: "lightgray",
          },
          dropdownStyle: {
            borderWidth: 2,
            borderTopWidth: 1,
            borderColor: "blue",
            minHeight: 50,
            maxHeight: 130,
            position: "absolute",
            zIndex: 9999,
            width: "100%",
            borderBottomRightRadius: 10,
            borderBottomLeftRadius: 10,
            marginTop: 30,
            backgroundColor: "white",
          },
          bgView:{
            height: 1,
            opacity: 0.2,
            backgroundColor: "#25243b",
            borderStyle: "solid",
            borderWidth: 1,
            borderColor: "#707070",
          },
        contentWrapper: {
            display: "flex",
            marginLeft: 50,
            paddingLeft: 40,
            paddingTop: 10,
            marginRight: 63,
        },
        footer: {
            flexDirection: "row",
            alignSelf: "flex-end",
            width: 220,
            height: 44,
        },
        inputWrapper: {
            marginLeft: "20%",
        },
        panWrapper: {
            flexDirection: "row",
            marginLeft: 0,
            justifyContent: "space-between",
            marginTop: 32,
        },
        validateButtonWrapper: {
            height: 44,
            width: 224,
            borderRadius: 22,
            backgroundColor: COLORS.shamrock,
        },
        empInfoWrapper: {
            gap: 15,
            marginTop: 32,
        },
        infoWrapper: {
            flexDirection: "row",
            gap: 120,
        },
        overlayViewStyle: {
            position: "absolute",
            zIndex: 9999,
            backgroundColor: "rgba(52,52,52,0.9)",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            borderRadius: 10,
        },
        labelStyle: {
            fontFamily: "Inter",
            fontWeight: "500",
            fontSize: 14,
            paddingVertical: 5,
            color: "#757575",
        },
        inlineError: {
            fontFamily: "Inter",
            fontSize: 12,
            color: "#db1a1a",
            marginTop: 3,
            marginLeft: 0,
        },
        empcontentViewStyle: {
            flexDirection: "row",
            zIndex: 1,
        },
        empSecondViewStyle: {
            marginLeft: 100,
            zIndex: 1,
        },
    },
    {
        [DEVICE_SIZES.LG]: {},
        [DEVICE_SIZES.MD]: {},
        [DEVICE_SIZES.SM]: {},
        [DEVICE_SIZES.XS]: {
            inputWrapper: {
                marginLeft: 0,
                marginTop: 63,
            },
            empcontentViewStyle: {
                flexDirection: "column",
                zIndex: 1,
            },
            empSecondViewStyle: {
                marginLeft: 0,
                zIndex: 1,
            },
            contentWrapper: {
                paddingLeft: 0,
                marginLeft: 10,
            },

            footer: {
                alignSelf: "center",
                marginTop: 20
            },
        },
    }
);
